/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV = [
  { to: '/', label: 'Inicio', nav: '01' },
  { to: '/artists', label: 'Artistas', nav: '02' },
  { to: '/videos', label: 'Videos', nav: '03' },
  { href: 'https://masteredtrax.shop', label: 'Tienda', nav: '04', external: true },
  { to: '/about', label: 'Label', nav: '05' },
  { to: '/contact', label: 'Contacto', nav: '06' },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const close = () => setOpen(false);

  return (
    <header className={`mt-nav ${onHome ? 'mt-nav--home' : 'mt-nav--page'} ${scrolled ? 'mt-nav--scrolled' : ''}`}>
      <div className="mt-nav__inner">
        <Link to="/" className="mt-nav__brand" onClick={close} aria-label="Mastered Trax">
          <span className="mt-nav__mark">Mastered Trax</span>
          <span className="mt-nav__sub">Record Label · Est. 2015</span>
        </Link>

        <nav className="mt-nav__links" aria-label="Primary">
          {NAV.map((item) => (
            item.external ? (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-nav__link mt-nav__link--shop"
              >
                <span className="mt-nav__num">{item.nav}</span>
                <span>{item.label}</span>
              </a>
            ) : (
              <Link
                key={item.to}
                to={item.to}
                className={`mt-nav__link ${location.pathname === item.to ? 'is-active' : ''}`}
              >
                <span className="mt-nav__num">{item.nav}</span>
                <span>{item.label}</span>
              </Link>
            )
          ))}
        </nav>

        <a
          href="https://masteredtrax.shop"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-nav__cart"
          aria-label="Open shop"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 5h3l2.4 11.2a1 1 0 0 0 1 .8H18a1 1 0 0 0 1-.8L21 8H7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="10" cy="20" r="1.3" fill="currentColor"/>
            <circle cx="17" cy="20" r="1.3" fill="currentColor"/>
          </svg>
          <span>Shop</span>
        </a>

        <button
          className={`mt-nav__burger ${open ? 'is-open' : ''}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>
      </div>

      <div className={`mt-nav__drawer ${open ? 'is-open' : ''}`}>
        <ul>
          {NAV.map((item) => (
            <li key={item.label}>
              {item.external ? (
                <a href={item.href} target="_blank" rel="noopener noreferrer" onClick={close}>
                  <em>{item.nav}</em>{item.label}
                </a>
              ) : (
                <Link to={item.to} onClick={close}>
                  <em>{item.nav}</em>{item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
        <div className="mt-nav__drawerFoot">
          <span>© Mastered Trax</span>
          <span>Guadalajara · Chicago</span>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
